import { useSearchParams } from "react-router-dom";
import { useApi } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { useSite } from "../lib/site";
import { PageHero, Loading, Reveal } from "../components/Common";
import { ProjectCard } from "../components/Cards";
import Seo from "../components/Seo";

export default function Developments() {
  const { t, tr } = useI18n();
  const { byKind, cityName } = useSite();
  const [params, setParams] = useSearchParams();
  const cat = params.get("category") || "";
  const city = params.get("city") || "";
  const q = new URLSearchParams(Object.entries({ category: cat, city }).filter(([, v]) => v));
  const { data, loading } = useApi(`/projects?${q.toString()}`);
  const set = (k, v) => { const p = new URLSearchParams(params); v ? p.set(k, v) : p.delete(k); setParams(p); };
  return (
    <div data-testid="developments-page">
      <Seo title={t("nav.developments")} description={t("project.sub")} />
      <PageHero eyebrow={t("nav.developments")} title={t("nav.developments")} sub={t("project.sub")} />
      <div className="container-lux py-12">
        <div className="mb-10 flex flex-wrap items-center gap-2" role="group">
          <button type="button" data-testid="project-filter-all" onClick={() => set("category", "")} className={`chip ${!cat ? "chip-on" : ""}`}>{t("project.all")}</button>
          {byKind("project_category").map((c) => (
            <button key={c.key} type="button" data-testid={`project-filter-${c.key}`} onClick={() => set("category", c.key)} className={`chip ${cat === c.key ? "chip-on" : ""}`}>{tr(c, "label")}</button>
          ))}
          {city && <button type="button" data-testid="project-filter-city-clear" onClick={() => set("city", "")} className="chip chip-on">{t("project.city")}: {cityName(city)} ✕</button>}
        </div>
        {loading ? <Loading /> : data?.length ? (
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {data.map((p, i) => (<Reveal key={p.id} delay={i * 0.05}><ProjectCard p={p} /></Reveal>))}
          </div>
        ) : <p data-testid="projects-empty" className="glass rounded-sm p-10 text-center text-fg/60">{t("project.none")}</p>}
      </div>
    </div>
  );
}
